import { useMasterDataProductPrices } from "@src/presentation/providers/MasterDataProductPricesDataProvider";
import { MasterDataListFooter } from "./MasterDataListFooter";

export const MasterDataProductPricesFooter = () => {
  const { total, page, limit, loading, setPage } = useMasterDataProductPrices();

  return (
    <MasterDataListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="Product Prices Pagination"
    />
  );
};
